export * from '../overrides/card';
import { Card } from '../overrides/card';

export default Card;
